import type { OrganizationRegion } from '~/common/types';

const CA: OrganizationRegion = {
  name: 'California',
  region: {
    type: 'Polygon',
    coordinates: [
      [
        [-125.15625000000001, 41.95131994679697],
        [-124.5849609375, 40.1452892956766],
        [-123.837890625, 38.85682013474361],
        [-120.69580078125001, 34.361576287484176],
        [-117.42187500000001, 32.491230287947594],
        [-114.54345703125, 32.731840896865684],
        [-114.32373046875, 34.813803317113155],
        [-119.94873046875, 38.89103282648846],
        [-119.99267578124999, 41.96765920367816],
        [-125.15625000000001, 41.95131994679697],
      ],
    ],
  },
};

export default CA;
